import { Card, CardContent } from "@/components/ui/card";
import { ReadShiftReportDepartmentEntry } from "@/types/shiftReportDepartmentEntry";
import { flexRender, Table } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import ShiftReportColumnHeader from "./ShiftReportColumnHeader";

interface ShiftReportDepartmentEntriesEditorProps {
  table: Table<ReadShiftReportDepartmentEntry>;
}

const ShiftReportDepartmentEntriesEditor = ({
  table,
}: ShiftReportDepartmentEntriesEditorProps) => {
  const { t } = useTranslation();

  return (
    <Card className="w-full h-full flex flex-col">
      {table.getHeaderGroups().map((headerGroup) => (
        <div
          key={headerGroup.id}
          className="grid grid-cols-12 gap-4 px-3 py-3 bg-slate-50 text-sm font-medium text-gray-500 rounded-lg"
        >
          {headerGroup.headers.map((header) => (
            <div
              key={header.id}
              className={header.column.columnDef.meta?.className}
            >
              {header.isPlaceholder ? null : (
                <ShiftReportColumnHeader header={header}>
                  {flexRender(
                    header.column.columnDef.header,
                    header.getContext(),
                  )}
                </ShiftReportColumnHeader>
              )}
            </div>
          ))}
        </div>
      ))}

      <CardContent className="flex-1 p-0">
        <div className="divide-y">
          {table.getRowModel().rows.map((row) => {
            return (
              <div
                key={row.id}
                className="grid grid-cols-12 gap-4 items-center px-3 py-1 transition-colors"
                data-testid="shift-report-entry"
              >
                {row.getVisibleCells().map((cell) => (
                  <div
                    key={cell.id}
                    className={cell.column.columnDef.meta?.className}
                  >
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </div>
                ))}
              </div>
            );
          })}

          {table.getRowModel().rows.length === 0 && (
            <div className="px-6 py-8 text-center text-gray-500">
              {t("common.noResults")}
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default ShiftReportDepartmentEntriesEditor;
